// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1x204","paramInput":"JobSimulator_paramInput__3PByu","input":"JobSimulator_input__27s63"};